import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Shield } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export const SiteHeader = ({ onBuy }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-amber-500/10 bg-[#06150F]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 sm:px-8">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5">
          <Logo className="h-9 w-9" />
          <span className="font-display text-lg font-bold tracking-tight text-amber-100">
            Avvento d'Oro
          </span>
        </Link>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link
                to={user.role === "admin" ? "/admin" : "/dashboard"}
                data-testid="header-area-button"
                className="inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-emerald-950/70 px-4 py-2 text-sm font-semibold text-amber-200 transition-colors hover:bg-emerald-900"
              >
                {user.role === "admin" ? <Shield className="h-4 w-4" /> : <LayoutDashboard className="h-4 w-4" />}
                <span className="hidden sm:inline">{user.role === "admin" ? "Pannello admin" : "Area personale"}</span>
              </Link>
              <button
                type="button"
                data-testid="header-logout-button"
                onClick={handleLogout}
                aria-label="Esci"
                className="rounded-full p-2 text-emerald-100/60 transition-colors hover:bg-white/5 hover:text-amber-200"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : (
            <>
              <Link
                to="/accedi"
                data-testid="header-login-link"
                className="text-sm font-semibold text-emerald-100/80 transition-colors hover:text-amber-200"
              >
                Accedi
              </Link>
              <button
                type="button"
                data-testid="header-buy-button"
                onClick={onBuy}
                className="rounded-full bg-gradient-to-r from-[#B82E3E] via-[#8B1E2B] to-[#6E1420] px-5 py-2 text-sm font-bold text-amber-100 shadow-[0_0_20px_rgba(184,46,62,0.35)] transition-transform duration-300 hover:scale-[1.04]"
              >
                Compra ora
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
